import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfCtaText, sfCtaUrl, sfHeadline, sfImage } from './sectionHelpers';

const ContentTextImage: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const variant = c.variant || section.variant || 'image_right';

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
        <div>
          {c.section_label && <span style={{ display: 'block', fontSize: '0.875rem', fontWeight: 600, color: 'var(--brand-primary, #2563eb)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>{c.section_label}</span>}
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ fontSize: '2.25rem', marginBottom: 16 }}
          >
            {sfHeadline(c, 'Heading')}
          </InlineEditText>
          <InlineEditText
            tag="p"
            controlKey="body"
            style={{ color: 'var(--brand-text-light, #64748b)', lineHeight: 1.7 }}
          >
            {c.body || 'Your body text goes here. Click to edit.'}
          </InlineEditText>
          {sfCtaText(c) && (
            <a href={sfCtaUrl(c)} className="sb-cta-btn" style={{ display: 'inline-block', marginTop: 16, padding: '12px 24px', borderRadius: 6, background: 'var(--brand-primary, #1a365d)', color: '#fff', fontWeight: 600, textDecoration: 'none', boxShadow: '0 4px 14px rgba(0,0,0,0.15)', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)' }}>
              {sfCtaText(c)}
            </a>
          )}
        </div>
        <div style={{ order: variant === 'image_left' ? -1 : 0 }}>
          {sfImage(c) ? (
            <img src={sfImage(c)} alt={c.image_alt || ''} style={{ width: '100%', borderRadius: 12, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -4px rgba(0,0,0,0.04)' }} />
          ) : (
            <div style={{ background: '#f1f5f9', borderRadius: 12, aspectRatio: '4/3', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>Image</div>
          )}
        </div>
      </div>
    </section>
  );
};
export default ContentTextImage;
